import { useCustomerDetailAppointmentsQuery } from "./use-customer-detail-appointments-query";

export const useCustomerDetailAppointments = (
  customerId: string,
  first?: number,
  after?: string
) => {
  const { data, loading, error, refetch, fetchMore } = useCustomerDetailAppointmentsQuery({
    customerId,
    first,
    after,
  });

  const loadMore = async () => {
    if (!data?.appointments?.pageInfo?.hasNextPage || !data?.appointments?.pageInfo?.endCursor) {
      return;
    }

    return fetchMore({
      variables: {
        customerId,
        first: first || 100,
        after: data.appointments.pageInfo.endCursor,
      },
    });
  };

  return {
    appointments: data?.appointments?.edges?.map(({ node }) => node) || [],
    loading,
    error,
    retry: refetch,
    loadMore,
    hasMore: data?.appointments?.pageInfo?.hasNextPage || false,
  };
};
